import { createRouter, createWebHistory } from 'vue-router'
import Login from '../components/Login.vue'
import ClassManager from '../components/ClassManager.vue'
import StockDataBrowser from '../components/StockDataBrowser.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/main',
    name: 'ClassManager',
    component: ClassManager,
    meta: { requiresAuth: true } // 需要认证
  },
  {
    path: '/student-browser',
    name: 'StockDataBrowser',
    component: StockDataBrowser,
    props: (route) => ({
      classInfo: route.query.classCode ? {
        classCode: route.query.classCode,
        className: route.query.className,
        majorCode: route.query.majorCode,
        academicYear: route.query.academicYear ? parseInt(route.query.academicYear) : null
      } : null
    }),
    meta: { requiresAuth: true } // 需要认证
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局前置路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否需要认证
  if (to.meta.requiresAuth) {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
    
    if (!isLoggedIn) {
      // 未登录，重定向到登录页
      next('/')
    } else {
      // 已登录，继续访问
      next()
    }
  } else {
    // 不需要认证的页面（如登录页）
    next()
  }
})

export default router
